import React from 'react';

import {observer} from 'mobx-react';

import {useStores} from '../../../Hooks';
import {permissionsEnum} from '../../../serverClientShared/sharedEnums';
import ConditionalComponent from '../../Shared/ConditionalComponent';
import PrivacySection from '../SettingsShared/PrivacySection';
import RoleVisibilitySection from './RoleVisibilitySection';

const sectionClass = 'px-5 py-4 flex flex-col gap-4 border-t border-panels-normal first:border-t-0';

const MirroredSettingsTab = observer(({settings}) => {
    const {generalStore, projectStore} = useStores();
    const t = generalStore.translate.bind(generalStore);
    const {editedPermittedRoles, togglePermittedRole} = settings;
    const isAdminOrOwner = generalStore.userIsWorkspaceAdminOrOwner();
    const isRoleVisibilityEnabled = !!generalStore.domainSettings?.IsRoleVisibilityEnabled;
    const canChangePermissions = projectStore.checkAllowedCurrentProject(permissionsEnum.CREATE_PROCEDURE_AND_SETTINGS, false);

    return (
        <div>
            <ConditionalComponent if={isAdminOrOwner}>
                <div className={sectionClass}>
                    <PrivacySection settings={settings} />
                </div>
            </ConditionalComponent>
            <ConditionalComponent if={isRoleVisibilityEnabled && canChangePermissions}>
                <div className={sectionClass}>
                    <RoleVisibilitySection permittedRoles={editedPermittedRoles} onToggle={togglePermittedRole} t={t} />
                </div>
            </ConditionalComponent>
        </div>
    );
});

export default MirroredSettingsTab;
